/* MOGA R64 — source-first contour export. No raster scanline paths.
   Binary geometry is traced at ORIGINAL image resolution. No smoothing,
   erosion, resampling or automatic deletion of small components. */
(function(){
'use strict';
const NS='http://www.w3.org/2000/svg';
const fmt=n=>Number(n.toFixed(5));
const esc=s=>String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&apos;'}[c]));
function parse(s){const d=new DOMParser().parseFromString(s,'image/svg+xml');if(d.querySelector('parsererror'))throw Error('Netaisyklingas SVG');return d}
function load(src){return new Promise((resolve,reject)=>{const im=new Image();if(/^https?:/i.test(src))im.crossOrigin='anonymous';im.onload=()=>resolve(im);im.onerror=()=>reject(Error('Originalus paveikslėlis nepasiekiamas arba CORS neleidžia jo skaityti'));im.src=src})}
function imageData(im){const c=document.createElement('canvas');c.width=im.naturalWidth;c.height=im.naturalHeight;if(!c.width||!c.height||c.width*c.height>24000000)throw Error('Originalas per didelis (maks. 24 MP). Naudokite mažesnį originalą.');const x=c.getContext('2d',{willReadFrequently:true});x.drawImage(im,0,0);return x.getImageData(0,0,c.width,c.height)}
function mask(data,w,h,threshold,alphaMode){
 const d=data, m=new Uint8Array(w*h);let count=0;
 for(let i=0;i<m.length;i++){const k=i*4,a=d[k+3];const lum=.2126*d[k]+.7152*d[k+1]+.0722*d[k+2];if(a>8&&(alphaMode?a/255*(255-lum)>255-threshold:lum<threshold)){m[i]=1;count++}}
 return {m,count};
}
/* Each exposed pixel edge is joined into closed boundaries. Unlike R62,
   horizontal scan runs are NEVER exported as separate filled rectangles. */
function contours(m,w,h){
 const edges=new Map(),key=(x,y)=>y*(w+1)+x;
 function edge(x,y,X,Y){const k=key(x,y),v=key(X,Y);let a=edges.get(k);if(!a)edges.set(k,a=[]);a.push(v)}
 const at=(x,y)=>x>=0&&y>=0&&x<w&&y<h&&m[y*w+x];
 for(let y=0;y<h;y++)for(let x=0;x<w;x++)if(at(x,y)){
  if(!at(x,y-1))edge(x,y,x+1,y);
  if(!at(x+1,y))edge(x+1,y,x+1,y+1);
  if(!at(x,y+1))edge(x+1,y+1,x,y+1);
  if(!at(x-1,y))edge(x,y+1,x,y);
 }
 const paths=[];let total=0;
 function point(k){return [k%(w+1),Math.floor(k/(w+1))]}
 while(edges.size){
  const start=edges.keys().next().value,pts=[point(start)];let cur=start,prev=null,guard=0;
  do{
   const list=edges.get(cur);if(!list||!list.length)throw Error('Kontūras nutrūko');
   let idx=0;
   if(list.length>1&&prev!==null){
    const [px,py]=point(prev),[cx,cy]=point(cur),dx=cx-px,dy=cy-py;
    const rank=v=>{const [nx,ny]=point(v),a=nx-cx,b=ny-cy;return (dx*b-dy*a<0?0:dx*a+dy*b>0?1:dx*b-dy*a>0?2:3)};
    idx=list.reduce((best,v,i)=>rank(v)<rank(list[best])?i:best,0);
   }
   const next=list.splice(idx,1)[0];if(!list.length)edges.delete(cur);
   prev=cur;cur=next;if(cur!==start)pts.push(point(cur));
   if(++guard>12000000)throw Error('Per sudėtingas kontūras');
  }while(cur!==start);
  // Remove only exactly collinear vertices; this changes no geometry.
  let changed=true;
  while(changed&&pts.length>3){changed=false;for(let i=0;i<pts.length;i++){const a=pts[(i+pts.length-1)%pts.length],b=pts[i],c=pts[(i+1)%pts.length];if((b[0]-a[0])*(c[1]-b[1])===(b[1]-a[1])*(c[0]-b[0])){pts.splice(i,1);changed=true;break}}}
  if(pts.length>=3){paths.push(pts);total+=pts.length}
  if(total>2500000)throw Error('Per daug kontūrų. Naudokite originalų SVG arba mažesnį paveikslėlį.');
 }
 return paths;
}
function trace(data,w,h,threshold,alphaMode){
 const {m,count}=mask(data,w,h,threshold,alphaMode);
 const paths=contours(m,w,h);
 const d=paths.map(pts=>'M'+pts.map(p=>p.join(' ')).join('L')+'Z').join('');
 return {d,count,paths:paths.length,vertices:paths.reduce((n,p)=>n+p.length,0)};
}
function cleanSvg(raw){
 const doc=parse(raw),svg=doc.documentElement;
 svg.querySelectorAll('.mg-product-bg,.mg-grid-rect,.mg-safe-zone,.mg-center-guide,#mgProductHole,#mgProductPhoto,#mgProductPhotoClip,[data-editor-only],.mg-selection-box,.mg-transform-ui').forEach(n=>n.remove());
 return doc;
}
function dimensions(j,order){const p=j.job?.product||order.product||{};return {w:Number(p.w),h:Number(p.h)}}
function root(w,h,viewBox){const d=document.implementation.createDocument(NS,'svg',null),s=d.documentElement;s.setAttribute('xmlns',NS);s.setAttribute('xmlns:xlink','http://www.w3.org/1999/xlink');s.setAttribute('width',w+'mm');s.setAttribute('height',h+'mm');s.setAttribute('viewBox',viewBox);return d}
function blob(doc){return new Blob([new XMLSerializer().serializeToString(doc)],{type:'image/svg+xml'})}
function href(im){return im.getAttribute('href')||im.getAttributeNS('http://www.w3.org/1999/xlink','href')||''}
async function nativeSource(src){
 if(!src||!(/\.svg(?:[?#]|$)/i.test(src)||/^data:image\/svg\+xml/i.test(src)))return null;
 let raw;
 if(/^data:/i.test(src)){const r=await fetch(src);raw=await r.text()}
 else{const r=await fetch(src,{mode:'cors',credentials:'omit'});if(!r.ok)throw Error('SVG HTTP '+r.status);raw=await r.text()}
 const d=parse(raw),s=d.documentElement;
 if(s.localName!=='svg')throw Error('Ne SVG dokumentas');
 if(s.querySelector('script,foreignObject,iframe,object,embed,animate,set,animateTransform,animateMotion'))throw Error('SVG turi nepalaikomų aktyvių elementų');
 if([...s.querySelectorAll('*')].some(n=>[...n.attributes].some(a=>/^on/i.test(a.name)||(/(?:href|url\()/i.test(a.name)&&/javascript:|https?:\/\//i.test(a.value)))))throw Error('SVG turi išorinių ar aktyvių nuorodų');
 return d;
}
function originalFor(o){return o?.originalSrc||o?.src||''}
function safeId(s){return String(s||'object').replace(/[^a-zA-Z0-9_-]/g,'_')}
async function build(j,order,opts={}){
 const {w,h}=dimensions(j,order);if(!(w>0&&h>0))throw Error('Neteisingi ruošinio matmenys');
 const source=cleanSvg(await j.svg.text()),src=source.documentElement;
 const vb=src.getAttribute('viewBox');if(!vb)throw Error('Šaltinio SVG neturi viewBox. Eksportas sustabdytas, kad nebūtų neteisingo mastelio.');
 const doc=root(w,h,vb),svg=doc.documentElement;
 const defs=source.querySelector('defs');if(defs)svg.appendChild(doc.importNode(defs,true));
 const objects=j.job?.objects||[],groups=[...src.querySelectorAll('[data-id]')];
 if(!groups.length)throw Error('Nerasti Studio objektai. Negalima saugiai atkurti vektoriaus.');
 const reports=[];let imageIndex=0;
 for(const g of groups){
  const o=objects.find(x=>String(x.id)===String(g.getAttribute('data-id')));
  if(!o)continue;
  const copy=doc.importNode(g,true);copy.removeAttribute('class');copy.setAttribute('id','MOGA_'+safeId(o.id));copy.setAttribute('data-moga-object',o.type);
  copy.querySelectorAll('[data-editor-only]').forEach(n=>n.remove());
  if(o.type==='image'){
   imageIndex++;
   const srcImage=originalFor(o);
   if(!srcImage)throw Error('Trūksta originalaus paveikslėlio '+imageIndex);
   const native=await nativeSource(srcImage);
   if(native){
    const image=copy.querySelector('image');if(!image)throw Error('Nerastas SVG paveikslėlio elementas');
    const nested=doc.importNode(native.documentElement,true);
    for(const attr of ['x','y','width','height','preserveAspectRatio'])if(image.hasAttribute(attr))nested.setAttribute(attr,image.getAttribute(attr));
    if(!nested.getAttribute('viewBox'))throw Error('Originalus SVG neturi viewBox — negalima saugiai išsaugoti mastelio');
    nested.setAttribute('overflow','hidden');
    image.replaceWith(nested);
    reports.push({object:o.id,method:'Native SVG preserved',source:srcImage,containsRaster:!!nested.querySelector('image'),fontDependent:!!nested.querySelector('text')});
    svg.appendChild(copy);continue;
   }
   const im=await load(srcImage),data=imageData(im),iw=data.width,ih=data.height;
   const alphaMode=!!(o.sourceHasAlpha||o.clientBgApplied||o.clientMaskSrc||o.adminEditedSrc);
   const threshold=Number(opts.threshold??128);
   const t=trace(data.data,iw,ih,threshold,alphaMode);
   const image=copy.querySelector('image');
   if(!image)throw Error('Nerastas paveikslėlio elementas '+imageIndex);
   const x=Number(image.getAttribute('x')||0),y=Number(image.getAttribute('y')||0),width=Number(image.getAttribute('width')),height=Number(image.getAttribute('height'));
   if(!(width>0&&height>0))throw Error('Neteisingas paveikslėlio dydis');
   const nested=doc.createElementNS(NS,'svg');nested.setAttribute('x',x);nested.setAttribute('y',y);nested.setAttribute('width',width);nested.setAttribute('height',height);nested.setAttribute('viewBox',`0 0 ${iw} ${ih}`);nested.setAttribute('preserveAspectRatio',image.getAttribute('preserveAspectRatio')||'xMidYMid meet');
   const path=doc.createElementNS(NS,'path');path.setAttribute('d',t.d);path.setAttribute('fill','#000');path.setAttribute('fill-rule','nonzero');path.setAttribute('stroke','none');nested.appendChild(path);image.replaceWith(nested);
   reports.push({object:o.id,source:srcImage,width:iw,height:ih,threshold,alphaMode,...{pixels:t.count,contours:t.paths,vertices:t.vertices}});
  }else{
   copy.querySelectorAll('text,tspan,textPath').forEach(n=>{n.setAttribute('fill','#000');n.removeAttribute('filter')});
   copy.querySelectorAll('[data-preview-ink]').forEach(n=>n.removeAttribute('data-preview-ink'));
  }
  svg.appendChild(copy);
 }
 if(!svg.querySelector('path,line,polyline,polygon,rect,circle,ellipse,text'))throw Error('Eksportas tuščias');
 const report={version:'R64',method:'Original-source boundary tracing; exact pixel boundaries; no scanline rectangles; no automatic smoothing',physicalMm:{w,h},images:reports,limitations:'Raster tracing cannot reconstruct missing source details or original font outlines. Native SVG text requires matching fonts. Verify LightBurn layers and preview before production.'};
 return {svg:blob(doc),report:new Blob([JSON.stringify(report,null,2)],{type:'application/json'}),data:report};
}
window.MOGA_GRAV_VECTOR_R64={build,trace,contours,mask};
})();
